import { useSupabaseTable } from './useSupabaseTable';

export function useTomadores() {
  return useSupabaseTable('tomadores', { orderBy: 'nome_fantasia', ascending: true });
}
